import {Component} from '@angular/core';

/* Shown for pages that do not have written instructions yet. Better than an
   empty dialog: it says plainly that nothing has been written, rather than
   implying the screen has no rules worth knowing. */
@Component({
    selector: 'app-default-help',
    template: `
        <p>There are no written instructions for this screen yet.</p>
        <p>
            Use the Help link in the sidebar to raise a question with the
            FareVantage team.
        </p>
    `
})
export class DefaultHelpComponent {
}
